import { Box, Flex, Text } from '@chakra-ui/react'
import React from 'react'

export default function ColorCode() {
    return (
        <Text mx="15px" color={"#fff"} fontWeight={"600"} fontSize={"12px"} pt="5px">Color Code for Qty Group: <Box fontWeight={"400"} as="span">
            <Flex color="white" justifyContent={"space-evenly"} fontWeight="500">
                <Box rounded="8px" p="8px" textAlign={"center"} bg="green">Good</Box>
                <Box rounded="8px" p="8px" textAlign={"center"} bg="purple">Serviceable</Box>
                <Box rounded="8px" p="8px" textAlign={"center"} bg="blue">Unserviceable</Box>
            </Flex>
        </Box></Text>
    )
}
